export const FETCH_INVITES = 'FETCH_INVITES'
export const FETCH_INVITES_ERROR = 'FETCH_INVITES_ERROR'
